<template>
	<section class="costompopup pop_xs" >
		<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
		
		<div class="middleBox platfromBox">
			<div class="modal-header darkBG border-bottom">
				<h4 class="modal-title">{{$t('selectTradingAccount')}}</h4>
				<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
				<button type="button" class="close" @click="selectTradingAccountFunc('')" >&times;</button>
			</div>
			<div class="modal-body p-0 scrollbar">
				<ul class="listingPopup" v-if="tradingAccountList.totalRecords > 0">
					<li  v-for="list in tradingAccountList.records" @click="selectTradingAccountFunc(list)" :class="(lastSelectTradingAccount != '' && lastSelectTradingAccount[0].account_id == list.account_id)?'active' :''">
						<div class="ittLeft">
							<span class="green bg"><img :src="'../../../../static/fxView/images/'+platformIcon[list.platform]" alt="Icon"> </span>
							<p class="ltBlock">{{list.account_id}}<span class="sp-small d-block">{{list.platform}}</span></p>
						</div>
						<div class="ittLeft items">
							<span class="sp-demo" v-html="(parseInt(list.demo_live) == 0)? 'demo' : 'live'"></span>
							<label class="fancy_radiochk_btn rounded" >
								<input type="checkbox" :checked="(lastSelectTradingAccount != '' && lastSelectTradingAccount[0].account_id == list.account_id)" >
								<span class="checkmark" ></span>
							</label>
							<!--<span class="sp-test">
								<a href="#">
									<feather type="settings"></feather>
								</a>
							</span>-->
						</div>
					</li>
				</ul>
				<div class="p-3 text-center"  v-else>
					<img src="../../../../static/fxView/images/lost.svg" alt="No Trading Account" width="150" class="mb-3">
					<p>{{$t('noTradingCreateNewOne')}}</p>
				</div>
				
			</div>
			<div class="modal-footer d-flex align-items-center justify-content-center">
				<a href="#" class="addBtn prism_btn btn_sm "  v-on:click="$parent.showTab = 'platform'">
				<feather type="plus"></feather>  {{$t('addNewTradAccount')}}</a> 
			</div>
		</div>
	</section>
</template>
<script>
	import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'Dashboard',
		mixins: [fxViewMixins],
        data() {
            return {
            	pageLoader : false,
            	response_msg : '',
				msg_type : '',
				platformIcon : {'MT4' : 'platforn-icon-1.svg' , 'MT5' : 'platforn-icon-3.svg','ACT' : 'platforn-icon-2.svg'},
            }
        },
		methods:{
			selectTradingAccountFunc(getData){
				this.$parent.showTab = ''
				if(getData != ''){
					let accountJson={
						'globalParams' : {
							'id' : getData.id
						},
						'localParams' : {'parameter' : this , 'getData' : [getData]}
					}
					this._runAddLastSelectTradingAccount(accountJson)
				}
			}
		}
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/trading_accounts.vue